import * as ai from "./modules/python/ai";

export default {
  ...ai
};
